import React from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const EightStep = ({setStep ,closeKYCModal}) => {
    const history=useHistory();

    const handleRedeem=()=>{
       closeKYCModal();
       history.push('/rewardStore', { scrollTo: 'rewards' });
    }
  return (
    <div>
        <div className="flex flex-col items-center justify-center py-3">
                    <h3 className="mt-2 font-semibold text-center text-gray-700">
                     Your KYC has been completed. You are ready to redeem your rewards.
                </h3>
                <button
                    className="mt-4 bg-primary text-white px-4 py-2 rounded "
                    onClick={handleRedeem}
                >
                   REDEEM
                </button>
                
            </div>
    </div>
  )
}

export default EightStep
